import { Content } from '@radix-ui/react-dropdown-menu'

import { styled } from '~/styled'

export const DropdownMenuContent = styled(Content, {
  base: [
    'bg-white',
    'rounded-sm',
    'shadow-sm',
    'py-2',
    'z-10',
    '[--slide-opacity-out:0]',
    'data-[side=top]:[--slide-direction-out-y:-4px]',
    'data-[side=right]:[--slide-direction-out-x:4px]',
    'data-[side=bottom]:[--slide-direction-out-y:4px]',
    'data-[side=left]:[--slide-direction-out-x:-4px]',
    'motion-safe:data-[state=open]:animate-slide-direction-in',
    'motion-safe:data-[state=closed]:animate-slide-direction-out'
  ]
})
